import { InventoryItemDisposition } from "@redotech/cockroachdb-codegen/tables/inventory/inventory-item-disposition";
import { InventoryItemKind } from "@redotech/cockroachdb-codegen/tables/inventory/inventory-item-kind";
import { accountIdFormat } from "@redotech/redo-account-id";
import { inventoryItemIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const ConsolidationInventoryItemSchema = z.object({
  cartonNumbers: z.array(z.number().int()),
  grade: z.string().nullable(),
  inventoryDisposition: z.enum(InventoryItemDisposition).nullable(),
  inventoryItemCreatedAt: z.date(),
  inventoryItemId: inventoryItemIdFormat.schema,
  inventoryItemRawId: z.string(),
  kind: z.enum(InventoryItemKind),
  merchantAccountId: accountIdFormat.schema,
  productId: productIdFormat.schema.nullable(),
  productSku: z.string().nullable(),
  productTitle: z.string().nullable(),
  returnId: z.string().nullable(),
});
